<script lang="ts" setup>
import RoundProgressBar from '@/corePagesModule/components/RoundProgressBar.vue';
import { computed } from 'vue';

// props
const props = withDefaults(
  defineProps<{
    numerator: number; // 分子
    denominator: number; // 分母
    detailInfo?: string; // サマリが何を表すか
    displayDetailItemType?: 'label' | 'tag'; // サマリが何を表すのか、それを表示する部分の形式 TODO: 型定義作る
  }>(),
  {
    detailInfo: '',
    displayDetailItemType: 'label',
  } // 初期値設定
);

// プログレスバーコンポーネントに渡す進捗率情報
const displayValue = computed(() => {
  return setProgressValue(props.numerator, props.denominator);
});

/**
 * 進捗率計算を行う
 * @param numerator - 達成件数(分子)
 * @param denominator - 総件数(分母)
 */
const setProgressValue = (numerator: number, denominator: number): number => {
  const value = Math.floor((numerator / denominator) * 100);
  if (Number.isNaN(value)) return 0;
  return value;
};
</script>

<template>
  <div class="summary-card-container">
    <div class="summary-card-content">
      <div class="summary-card-progress-bar summary-card-content__progress-bar">
        <RoundProgressBar :progress="displayValue" />
      </div>
      <div class="summary-card-content__item-count-label-container">
        <label class="summary-card-content__item-count-container--label">
          <!-- 仕入先内示の作成件数を出力する関数を作成して入れる -->
          {{ `${props.numerator}/${props.denominator}` }}
        </label>
      </div>
      <template v-if="props.displayDetailItemType === 'label'">
        <div class="summary-card-info__display-detail-label-container">
          <label class="summary-card-info__display-detail--label">
            <!-- 仕入先内示の詳細を表示する関数を入れる -->
            {{ props.detailInfo }}
          </label>
        </div>
      </template>
      <template v-if="props.displayDetailItemType === 'tag'">
        <!-- タグの一覧表示を作る -->
        <div />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.summary-card-container {
  min-width: 132px;
  min-height: 173px;
  border: 1px solid;
  border-color: $border;
  border-radius: 4px;
  padding: 8px 0px 16px 0px;
}
.summary-card-content {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

.summary-card-progress-bar {
  margin: 0px auto 0px auto;
  width: 101px;
  height: 101px;
}

.summary-card-content__item-count-label-container {
  height: 20px;
  margin: 0px 4px 4px 4px;
  text-align: center;
  &--label {
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
  }
}
.summary-card-info__display-detail-label-container {
  height: 20px;
  margin: 0px 4px 4px 4px;
  text-align: center;
  &--label {
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
  }
}
</style>
